let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a44ce")).then(() => parcelRequire('3srOK'));